export const SPIN_CONTRACT_ADDRESS = 'spot.spin-fi.near';
